var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"white--text text-none",attrs:{"loading":_vm.submit_loading,"disabled":_vm.submit_loading,"color":_vm.color,"text":_vm.just_text,"large":""},on:{"click":_vm.submitFunction}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }